import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const MpowerFinancingLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. What is the purpose of a support letter in MPOWER Finance?",
            content: "MPower Finance offers a visa support letter that students can utilize to secure their I-20 form needed for obtaining a student visa in the US."
        },
        {
            title: "2. What is the origination fee for a student loan from MPOWER Finance?",
            content: "This fee is comparable to what other lenders charge as a processing fee. The only variation is that it is added to the loan amount and is levied for every disbursal."
        },
        {
            title: "3. What additional services does MPOWER Finance offer?",
            content: "They provide Path2Success career service programs, scholarships, refinancing, and more."
        },
        {
            title: "4. Does MPOWER Financing provide financial assistance for living expenses?",
            content: "Yes. It provides for living expenses; however, the applicant must collaborate with the institution’s financial support office to get living expenses because the whole money granted will be sent straight to the university."
        }, {
            title: "5. Can I receive an MPOWER loan to finance my remaining semesters of education?",
            content: "Absolutely! It is possible to apply for an education loan at any point during your studies. However, there are certain requirements that you need to meet. Firstly, you should be either an undergraduate or a graduate student. Additionally, you should be within two years of completing your degree or about to start a one-year or two-year program."
        }, {
            title: "6. When does the loan EMI for MPOWER Financing begin?",
            content: "Payment of the principal amount begins 6 months after completing the course. Only simple interest needs to be paid until then."
        },
        {
            title: "7. What is the functioning process of the MPOWER student loan?",
            content: "Education loans are available to you without the need for a co-applicant or collateral. MPOWER offers a range of schools and courses, and if your desired institute is included in their list, you can qualify for a student loan from them."
        }, {
            title: "8. Can I get a loan from MPOWER for studying at a UK university?",
            content: "You are unable to obtain an education loan for the UK with MPOWER Financing as it only offers loans for the USA and Canada."
        }, {
            title: "9. Is MPOWER Financing a safe option?",
            content: "MPOWER Financing has been providing safe options for international students since its establishment in 2014. Many students have successfully pursued their dream of studying abroad with the help of MPOWER Financing."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"MPOWER Education Loan"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"MPOWER Education Loan"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">MPOWER Financing Education Loan for Abroad Studies</h5>
                            <p className="loan-elegibility-des">The process of obtaining financial aid for educational purposes can often be daunting, with numerous hurdles to overcome. However, there is no need for concern any longer, as Credere has collaborated with MPOWER Financing to offer assistance in obtaining a study abroad loan devoid of the necessity for collateral or a co-signer.
                                <br /><br />
                                MPOWER Financing was established in 2014 to eliminate the financial barriers that hinder educational opportunities worldwide. This firm, which has its headquarters in Washington, DC, specializes in offering student loans to those who are going to university in the US and Canada. MPOWER Financing seeks to increase the accessibility of high-quality education for students internationally by providing financial help. MPOWER can provide financial assistance to more than 400 educational institutions.
                                <br /><br />
                                The entire loan application process is conducted online, enhancing the convenience for borrowers seeking financial assistance. By eliminating the necessity for in-person visits or paper documentation, users may simply apply for a loan from the comfort of their own homes. This streamlined approach not only saves time but also simplifies the overall borrowing experience.</p>

                            <h5 className="about-head">MPOWER Financing USP:</h5>
                            <p className="loan-elegibility-des">No collateral or cosigner is required for these loans, as the decision to approve a loan is based on the borrower’s potential for the future rather than their financial background or current assets.</p>
                            <h5 className="about-head">Overview of MPOWER Financing Abroad Education Loan</h5>
                            <p className="loan-elegibility-des">International students can apply for study abroad loans from MPOWER Financing at affordable interest rates, with no need for collateral or co-applicant. Education loans are exclusively offered by the lender to educational institutions situated in the USA or Canada. Depending on your university, the loan amount is given in either USD or CAD. The table below lists some additional advantages of the MPOWER education loan for you.</p>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Description	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            12.99%-15.99%
                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">
                                            Up to 100,000 USD

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            APR*</td>
                                        <td className="">

                                            For Graduate Programs- 13.98% For Undergraduate Programs - 15.01%

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Interest Rate Discount
                                        </td>

                                        <td className="">
                                            0.25%(if you sign-up for autopay)</td>

                                    </tr>
                                    <tr>
                                        <td className="">

                                            Interest Rate Type</td>
                                        <td className="">

                                            Fixed Interest Rate
                                        </td>


                                    </tr>

                                    <tr>
                                        <td>
                                            Minimum Income</td>
                                        <td>N/A</td></tr>
                                    <tr>
                                        <td>Repayment</td>
                                        <td>Simple Interest during the course and also during 6 Month grace period</td>
                                    </tr>
                                    <tr>
                                        <td>Processing Fees</td>
                                        <td>5% (adjusted in the loan amount, No upfront payment )</td>
                                    </tr>
                                    <tr>
                                        <td>Other Charges</td>
                                        <td>N/A</td>
                                    </tr>
                                    <tr>
                                        <td>Margin Money</td>
                                        <td>0</td>
                                    </tr>
                                    <tr>
                                        <td>Loan Tenure</td>
                                        <td>Upto 10 years</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="loan-elegibility-des">APR, or Annual Percentage Rate, is the annual interest rate on investments. However, it does not consider the impact of compounding interest during the year.</p>

                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">

                            <h5 className="about-head">Criteria for eligibility for MPOWER Financing education loan</h5>
                            <p className="loan-elegibility-des">The following requirements must be met for you to be qualified for a loan from MPOWER Financing.</p>
                            <ol className="loan-elegibility-ul">
                                <li>To be eligible, you must be a student currently enrolled in either an undergraduate or graduate program, with no more than two years left until graduation. Alternatively, you can also apply if you are just about to start a one-year or two-year program.</li>
                                <li>Enrolled in or currently studying at any of their 400+ accredited institutions in the United States or Canada.</li>
                                <li>Aspiring to study overseas, you have to be an Indian student.</li>
                            </ol>
                            <h5 className="about-head">Courses that have been approved by MPOWER Financing.</h5>


                            <p className="loan-elegibility-des">Your educational objectives are unique to MPOWER education loans. They therefore support the whole range of degree types:</p>
                            <ol className="subhead-ul">
                                <li>Master’s</li>
                                <li>Ph.D.</li>
                                <li>MBA</li>
                                <li>Bachelor’s</li>
                                <li>J.D.</li>
                                <li>M.D.</li>
                                <li>D.D.S.</li>
                                <li>LL.M.</li>
                                <li>Diploma and Associates (Canada only)</li>
                            </ol>


                            <h5 className="about-head">Required Documents for an Education Loan from MPOWER Financing</h5>
                            <p className="loan-elegibility-des">MPOWER has simpler document requirements than traditional banks, but there are still a few key documents that you must submit. These mandatory documents include –</p>


                            <p className="loan-elegibility-des">
                                <b>Resume/CV –</b> it needs to showcase the qualifications and work experience of the candidate.
                                <br /><br />
                                <b>Proof of home country address –</b> You can submit any utility bill, banking statement, or signed lease.
                                <br /><br />
                                <b>Secondary photo ID –</b> Any ID provided by the government is included.
                                <br /><br />
                                <b>Standardized test scores –</b> Graduate studies often require applicants to take standardized tests like the GRE or GMAT. Additionally, international students must also provide proof of their language proficiency by submitting scores from tests such as the TOEFL or IELTS.
                                <br /><br />
                                You need to have a valid passport and photo ID from your home country, as well as a valid visa for the United States.
                                <br /><br />
                                Documents of current study or acceptance letters from the university you want to attend.
                                <br /><br />
                                Previous academic certificates
                                <br /><br />
                                Summary of the university’s fee structure (estimated cost).</p>
                            <h5 className="about-head">Steps to apply for an education loan at MPOWER Financing via Credere</h5>
                            <p className="loan-elegibility-des">You can apply online at MPOWER Financing’s website to qualify for a loan to study abroad. However, applying for your education loan with Credere offers an effortless process.
                                <br /><br />
                                Credere is a digital platform specifically created to help Indian students fund their overseas education. To start your journey with us, simply verify your loan eligibility and let us take care of the rest!</p>
                            <h5 className="about-head">Reasons to choose Credere for an education loan from MPOWER Financing</h5>



                            <p className="loan-elegibility-des"><b>Best Loan Assurance</b></p>
                            <p className="loan-elegibility-des">Our mission at Credere is to support students in pursuing their educational dreams by offering affordable loan options. We guarantee that you will receive the most competitive deal available. If you find a better offer somewhere else, we will match the interest rates for the entire duration of your education loan.</p>
                            <p className="loan-elegibility-des"><b>Entirely Online Process</b></p>
                            <p className="loan-elegibility-des">The MPOWER Financing Education Loan is completely online, eliminating the need for students to visit the company. Credere will guide you through the entire process, ensuring a smooth experience.</p>
                            <p className="loan-elegibility-des"><b>Rapid Response Time</b></p>
                            <p className="loan-elegibility-des">Credere’s education counselor plays a crucial role in facilitating the speedy approval of loans, making it possible to secure funding within a short timeframe of 3 to 7 days after submitting the needed paperwork. </p>
                            <p className="loan-elegibility-des"><b>Conditional Loan Offer</b></p>
                            <p className="loan-elegibility-des">You will be able to quickly receive a conditional loan offer from MPOWER with Credere’s assistance, allowing you to begin the visa application process immediately.</p>
                            <p className="loan-elegibility-des"><b>Loan Top-up</b></p>
                            <p className="loan-elegibility-des">MPOWER can give a top-up on the allowed loan amount (from Avanse & Incred only) if it is less than what was needed to fulfill the conditions.</p>
                            <h5 className="about-head">Ways to get in touch with MPOWER Financing for a Student Loan</h5>
                            <p className="loan-elegibility-des">You may get in touch with MPOWER financing in several ways, including:</p>
                            <p className="loan-elegibility-des"><b>Contacting MPOWER Financing via email</b></p>
                            <p className="loan-elegibility-des">Email ID: info@mpowerfinancing.com
                                <br />
                                You may always contact MPOWER Financing by email at the previously mentioned address if you have queries or require any form of support.</p>
                            <p className="loan-elegibility-des"><b>Filling out the Online Contact Form</b></p>
                            <p className="loan-elegibility-des">Visit – <a href="https://www.mpowerfinancing.com/contact-us" style={{ textDecoration: "none", color: "var(--primarycolor" }}> www.mpowerfinancing.com/contact-us</a>
                                <br />
                                On their official website, there is an online contact form that you can fill out with some basic information. Once all of these requirements are completed, they are forwarded to MPOWER Financing’s customer care staff, who will get in touch with you.</p>
                            <p className="loan-elegibility-des"><b>Office visit</b></p>
                            <p className="loan-elegibility-des">Address: 837, 1, 100 Feet Rd, Indira Nagar 1st Stage, H Colony, Indiranagar, Bengaluru, Karnataka 560038
                                <br /><br />
                                You can visit the necessary staff at the MPOWER Financing India office listed above. Before you get there, confirm that you have an appointment.
                                <br /><br />
                                No need to reach out to MPOWER directly when applying for an education loan. The entire application process for the loan is done online.
                                <br /><br />
                                If you select Credere, their Loan Counsellor will serve as your mentor and manage all communications with MPOWER Financing on your behalf. This indicates that as Credere will handle everything on your behalf, you may obtain an education loan to study abroad without running into unnecessary difficulties. This simplified process guarantees that you may quickly and easily obtain the money you want.</p>
                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default MpowerFinancingLendingPartner;